import React, { useState, useEffect } from "react";
import { Redirect } from "react-router";
import DocumentTitle from "react-document-title";
import "babel-polyfill";

import "bootstrap/dist/css/bootstrap.min.css";
import "jquery-ui/themes/base/all.css";
import "nouislider/distribute/nouislider.css";
import "select2/dist/css/select2.css";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./App.css";

import { surveyLocalization } from "survey-core";

import api from "./admin/services/Api";
import Error from "./components/Error";
import Loader from "./components/Loader";
import BackgroundedScreen from "./components/BackgroundedScreen";
import Login from "./components/Login";

import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker.js";
import "select2/dist/js/select2.js";
import "pretty-checkbox";
import "jquery-bar-rating/jquery.barrating.js";
import "jquery-bar-rating/dist/themes/fontawesome-stars.css";
import "jquery-bar-rating/dist/themes/bars-1to10.css";
import "jquery-bar-rating/dist/themes/bars-movie.css";
import "jquery-bar-rating/dist/themes/bars-pill.css";
import "jquery-bar-rating/dist/themes/bars-reversed.css";
import "jquery-bar-rating/dist/themes/bars-horizontal.css";
import "jquery-bar-rating/dist/themes/css-stars.css";
import "jquery-bar-rating/dist/themes/fontawesome-stars-o.css";
import * as SurveyCore from "survey-core";
import { jquerybarrating } from "surveyjs-widgets";
import "survey-core/defaultV2.css";
import useOnlineStatus from "./hooks/useOnlineStatus";
import ConnectionStatus from "./components/hud/ConnectionStatus";
import ResetSurveyButton from "./components/hud/ResetSurveyButton";
import { checkInternet } from "./utils/helpers";
import { useHistory } from "react-router-dom";

// Use localforage for all client-side storage
import localforage from "localforage";

// Dedicated IndexedDB store for offline surveys
import {
    getAll as offlineGetAll,
    upsert as offlineUpsert,
    remove as offlineRemove,
    clear as offlineClear,
    requestDurablePersistence
} from "./storage/offlineSurveysStore";

jquerybarrating(SurveyCore);

// Key for the localforage cache of the static survey definition
const STATIC_SURVEY_KEY = "static_survey_data";

export function App(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorTitle, setErrorTitle] = useState(false);
    const [survey, setSurvey] = useState(null);
    const [requiresLogin, setRequiresLogin] = useState(false);
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const [sessionErrorMessage, setSessionErrorMessage] = useState(null);
    const [formData, setFormData] = useState(null);
    const [activeLanguage, setActiveLanguage] = useState("fr");

    const [surveyPost, setSurveyPost] = useState({});
    const [temporaryPostId, setTemporaryPostId] = useState(null);

    const [currentUser, setCurrentUser] = useState(null);

    const [showRelaunchButton, setShowRelaunchButton] = useState(false);
    const [showHudReset, setShowHudReset] = useState(false);
    const [showHudStatus, setShowHudStatus] = useState(false);

    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isCompleted, setIsCompleted] = useState(null);
    const [isCheckingSession, setIsCheckingSession] = useState(null);
    const [isAuthorizedForSurvey, setIsAuthorizedForSurvey] = useState(null);
    const [surveyModel, setSurveyModel] = useState(null);

    const isOnline = useOnlineStatus();
    const history = useHistory();

    useEffect(() => {
        requestDurablePersistence();

        const loadAndPrefill = async () => {
            const fetchedSurvey = await fetchSurveyFromApi();
            setIsLoading(false);
            setHasLoadedOnce(!errorMessage);
            await prefillFormFromQuery(fetchedSurvey);
        };

        if (!props.match || !props.match.params || !props.match.params.surveyslug) {
            setErrorMessage("Survey does not exist");
            return;
        }

        if (!hasLoadedOnce && errorMessage === false) {
            loadAndPrefill();
        }

        // Ensure Popper is present globally for third-party widgets relying on it
        const Popper = require("popper.js/dist/umd/popper.min");
        window["Popper"] = Popper;
        global["Popper"] = Popper;
        window["$"] = window["jQuery"] = $;
        global["$"] = global["jQuery"] = $;

        document.documentElement.lang = activeLanguage;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Pre-fill some fields and optionally hide blocks based on URL query params.
     */
    const prefillFormFromQuery = async (surveyFromApi = null) => {
        const queryParams = getUrlQueryParameters(surveyFromApi);
        if (Object.keys(queryParams).length) {
            Object.keys(queryParams).forEach((key) => {
                if (!key) return;
                const parentSelector = "[data-key=" + key + "0]";
                if (key.indexOf("hidden") > 0) {
                    // Hide the target block
                    const selectorToHide = parentSelector.replace("hidden", "");
                    const el = document.querySelector(selectorToHide);
                    if (el && el.parentNode && el.style) {
                        el.style.visibility = "hidden";
                        el.style.height = "0";
                        const parent = el.parentNode;
                        if (parent && parent.style) {
                            parent.style.minHeight = "0";
                            parent.style.margin = "0";
                        }
                    }
                }
            });
        }
    };

    /**
     * Find a survey element by its name within the JSON definition.
     */
    const getSurveyElement = (name, json) => {
        for (const p in json.pages) {
            for (const q in json.pages[p].elements) {
                if (json.pages[p].elements[q].name === name) {
                    return json.pages[p].elements[q];
                }
            }
        }
        return null;
    };

    /**
     * Read URL query parameters and coerce values based on the element type if available.
     */
    const getUrlQueryParameters = (fetchedSurvey = null) => {
        const params = new URLSearchParams(window.location.search.substr(1));
        const result = {};
        for (let [param, value] of params.entries()) {
            if (fetchedSurvey && typeof fetchedSurvey.json === "object") {
                const element = getSurveyElement(param, fetchedSurvey.json);
                if (element && ["barrating", "rating"].indexOf(element.type) !== -1) {
                    result[param] = `${value}` === `${parseInt(value)}` ? parseInt(value) : value;
                } else {
                    result[param] = value;
                }
            } else {
                result[param] = value;
            }
        }
        return result;
    };

    /**
     * Initialize SurveyJS model from the loaded definition, taking locale, page, and data into account.
     */
    const initModel = (loadedSurvey = null, locale = null) => {
        const json = (loadedSurvey || survey).json;

        // Normalize renderers and optionally shuffle choices
        for (const p in json.pages) {
            for (const q in json.pages[p].elements) {
                if (["radiogroup", "checkbox", "boolean", "matrix"].indexOf(json.pages[p].elements[q].type) > -1) {
                    json.pages[p].elements[q].renderAs = "prettycheckbox";
                }
                if (json.pages[p].elements[q].choicesOrder === "random") {
                    json.pages[p].elements[q].choices = json.pages[p].elements[q].choices.sort(() => Math.random() - 0.5);
                }
            }
        }

        surveyLocalization.defaultLocale = "fr";

        const newModel = new Model({ ...json });
        newModel.locale = locale || activeLanguage;
        newModel.currentPageNo = currentPageIndex;
        newModel.data = formData;
        setSurveyModel(newModel);
    };

    /**
     * Cache the survey definition in localforage.
     */
    const cacheStaticSurvey = async (surveyData) => {
        await localforage.setItem(STATIC_SURVEY_KEY, surveyData);
    };

    /**
     * Read the cached survey definition from localforage.
     */
    const readCachedStaticSurvey = async () => {
        return await localforage.getItem(STATIC_SURVEY_KEY);
    };

    /**
     * Load survey + initial post from the API, then prepare the SurveyJS model.
     */
    const fetchSurveyFromApi = async () => {
        setIsLoading(true);
        setErrorMessage(false);
        let queryParams = getUrlQueryParameters(null);
        try {
            if (queryParams["hudStatus"] !== undefined) {
                setShowHudStatus(queryParams["hudStatus"] === "true");
            }
            if (queryParams["hudReset"] !== undefined) {
                setShowHudReset(queryParams["hudReset"] === "true");
            }

            const apiResponse = await api.getSurvey(props.match.params.surveyslug, queryParams["prid"]);
            const { survey: surveyData, answers, currentPage = 0 } = apiResponse;

            await cacheStaticSurvey(surveyData);

            if (surveyData && surveyData.customFields && !surveyData.customFields.enabled) {
                setErrorMessage(surveyData.customFields.surveyDisabledError);
                setIsLoading(false);
                setHasLoadedOnce(false);
            }

            queryParams = getUrlQueryParameters(surveyData);

            setSurvey(surveyData);
            await initModel(surveyData);
            setFormData({ ...answers, ...queryParams });
            setCurrentPageIndex(currentPage);
            setErrorMessage(false);
            setSurveyPost(apiResponse);
            setIsLoading(false);
            return surveyData;
        } catch (e) {
            let customFields = {};
            if (e.response && e.response.customFields) {
                customFields = e.response.customFields;
            }
            if (e.statusCode === 403) {
                if (!currentUser) {
                    setErrorMessage(false);
                    setRequiresLogin(true);
                    setIsAuthenticated(false);
                    setSurvey({ customFields });
                    await checkSessionConnection();
                } else {
                    setErrorMessage(customFields && customFields.notAuthorizedSurvey ? customFields.notAuthorizedSurvey : "You are not allowed to complete this survey");
                    setRequiresLogin(true);
                    setIsAuthenticated(false);
                    setSurvey({ customFields });
                }
                return;
            }
            if (e.statusCode === 401) {
                setErrorMessage(customFields && customFields.surveyAlreadyDone ? customFields.surveyAlreadyDone : "You've already completed this survey");
                setRequiresLogin(true);
                setIsAuthenticated(true);
                setSurvey({ customFields });
                return;
            }
            setErrorMessage(e.response && typeof e.response === "object" && e.response.message ? e.response.message : e.message);
            setErrorTitle("Oops!");
            return;
        }
    };

    /**
     * Load survey from local cache (offline flow). If online, reload the page URL to restart the normal flow.
     */
    const loadSurveyFromLocalCache = async (hudResetUrl = null) => {
        if (isOnline) {
            window.location.replace(hudResetUrl);
        } else {
            setIsLoading(true);
            setErrorMessage(false);
            setShowRelaunchButton(false);
            let queryParams = getUrlQueryParameters(null);
            try {
                if (queryParams["hudStatus"] !== undefined) {
                    setShowHudStatus(queryParams["hudStatus"] === "true");
                }
                if (queryParams["hudReset"] !== undefined) {
                    setShowHudReset(queryParams["hudReset"] === "true");
                }
                setSurveyPost({});

                const surveyData = await readCachedStaticSurvey();

                const initialAnswers = {};
                const initialPage = 0;
                const tempId = crypto.randomUUID();
                setTemporaryPostId(tempId);

                if (surveyData && surveyData.customFields && !surveyData.customFields.enabled) {
                    setErrorMessage(surveyData.customFields.surveyDisabledError);
                    setIsLoading(false);
                    setHasLoadedOnce(false);
                }
                queryParams = getUrlQueryParameters(surveyData);

                setSurvey(surveyData);
                await initModel(surveyData);
                setFormData({ ...initialAnswers, ...queryParams });
                setCurrentPageIndex(initialPage);
                setErrorMessage(false);
                setIsCompleted(false);
                setHasLoadedOnce(true);
                setIsLoading(false);
                await prefillFormFromQuery(surveyData);
                return surveyData;
            } catch (e) {
                let customFields = {};
                if (e.response && e.response.customFields) {
                    customFields = e.response.customFields;
                }
                if (e.statusCode === 403) {
                    if (!currentUser) {
                        setErrorMessage(false);
                        setRequiresLogin(true);
                        setIsAuthenticated(false);
                        setSurvey({ customFields });
                        await checkSessionConnection();
                    } else {
                        setErrorMessage(customFields && customFields.notAuthorizedSurvey ? customFields.notAuthorizedSurvey : "You are not allowed to complete this survey");
                        setRequiresLogin(true);
                        setIsAuthenticated(false);
                        setSurvey({ customFields });
                    }
                    return;
                }
                if (e.statusCode === 401) {
                    setErrorMessage(customFields && customFields.surveyAlreadyDone ? customFields.surveyAlreadyDone : "You've already completed this survey");
                    setRequiresLogin(true);
                    setIsAuthenticated(true);
                    setSurvey({ customFields });
                    return;
                }
                setErrorMessage(e.response && typeof e.response === "object" && e.response.message ? e.response.message : e.message);
                setErrorTitle("Oops!");
                return;
            }
        }
    };

    useEffect(() => {
        if (survey && survey.json) {
            prefillFormFromQuery(survey);
        }
    }, [survey, surveyModel]);

    /**
     * Coerce answer types to numbers when the question type requires it.
     */
    const coerceAnswerTypes = (answersData) => {
        const result = {};
        for (const key of Object.keys(answersData || {})) {
            const element = survey && survey.json ? getSurveyElement(key, survey.json) : null;
            if (element && ["barrating", "rating"].indexOf(element.type) !== -1) {
                result[key] = `${answersData[key]}` === `${parseInt(answersData[key])}` ? parseInt(answersData[key]) : answersData[key];
            } else {
                result[key] = answersData[key];
            }
        }
        return result;
    };

    /**
     * Save a local snapshot (completed or partial) into the IndexedDB offline store.
     */
    async function saveOfflineSurveyEntry(surveySnapshot, localStatus, options = null) {
        if (surveyPost && surveyPost._id) {
            surveySnapshot._id = surveyPost._id;
        } else {
            surveySnapshot._id = temporaryPostId;
        }

        const partialData = {
            status: localStatus,
            result: {
                _id: surveySnapshot._id,
                data: await coerceAnswerTypes(surveySnapshot.data),
                currentPageNo: surveySnapshot.currentPageNo
            },
            options: options
        };

        await offlineUpsert(surveySnapshot._id, partialData);
    }

    /**
     * Send a completed survey to the server and update local state accordingly.
     */
    async function submitSurveyToServer(localSurveyPacket, targetPost = null, asynchronousRegister = false) {
        try {
            const postToUse = targetPost || surveyPost;

            if (localSurveyPacket.options && localSurveyPacket.options.hasOwnProperty("showDataSaving")) {
                localSurveyPacket.options.showDataSaving();
            }

            const postApi = await api.saveSurveyPost(postToUse._id, { answers: localSurveyPacket.result.data }, true);

            if (!showHudStatus) {
                setFormData(
                    coerceAnswerTypes({
                        ...formData,
                        ...localSurveyPacket.result.data
                    })
                );
                setSurveyPost(postApi);
                setIsCompleted(true);
            } else {
                if (!asynchronousRegister) {
                    setFormData(
                        coerceAnswerTypes({
                            ...formData,
                            ...localSurveyPacket.result.data
                        })
                    );
                    setSurveyPost(postApi);
                    setIsCompleted(true);
                }
            }

            if (localSurveyPacket.options && localSurveyPacket.options.hasOwnProperty("showDataSavingSuccess")) {
                localSurveyPacket.options.showDataSavingSuccess();
            }
        } catch (e) {
            if (e.statusCode && e.statusCode === 403) {
                setRequiresLogin(true);
                setHasLoadedOnce(false);
                setIsAuthenticated(false);
                setSessionErrorMessage(survey && survey.customFields ? survey.customFields.sessionError : null);
            } else {
                const err = new Error(e && e.message ? e.message : "Save failed");
                err.context = {
                    ...e,
                    answers: {
                        ...formData,
                        ...localSurveyPacket.result.data
                    },
                    post: surveyPost ? surveyPost : null,
                    completed: true
                };
                throw err;
            }

            if (localSurveyPacket.options && typeof localSurveyPacket.options.showDataSavingError === "function") {
                localSurveyPacket.options.showDataSavingError();
            }
        }
    }

    /**
     * SurveyJS `onComplete` handler.
     */
    const onComplete = async (result, options) => {
        if (showHudStatus) {
            const online = await checkInternet();
            const localPacket = { result, options };
            setShowRelaunchButton(result.currentPageNo >= survey.json.pages.length - 1);

            if (online !== true) {
                await saveOfflineSurveyEntry(result, "completed", options);
            } else {
                const targetPostId = result._id ? result._id : surveyPost._id;
                const ensuredPost = await getOrInitPost(targetPostId);
                await submitSurveyToServer(localPacket, ensuredPost);
            }
        } else {
            options.showDataSaving && options.showDataSaving();
            try {
                const postApi = await api.saveSurveyPost(surveyPost._id, { answers: result.data }, true);

                setFormData((prev) =>
                    coerceAnswerTypes({
                        ...prev,
                        ...result.data
                    })
                );

                setSurveyPost(postApi);
                setIsCompleted(true);
                options.showDataSavingSuccess && options.showDataSavingSuccess();
            } catch (e) {
                if (e && e.statusCode === 403) {
                    setRequiresLogin(true);
                    setHasLoadedOnce(false);
                    setIsAuthenticated(false);
                    setSessionErrorMessage(survey && survey.customFields ? survey.customFields.sessionError : null);
                    options.showDataSavingError && options.showDataSavingError();
                } else {
                    options.showDataSavingError && options.showDataSavingError();
                    const message = e && e.message ? e.message : "Survey save failed";
                    const err = new Error(message);
                    err.context = {
                        answers: {
                            ...formData,
                            ...result.data
                        },
                        post: surveyPost || null,
                        completed: true
                    };
                    throw err;
                }
            }
        }
    };

    /**
     * SurveyJS `onPartialSend` handler.
     */
    const onPartialSend = async (result) => {
        const online = await checkInternet();

        if (showHudStatus && online !== true) {
            await saveOfflineSurveyEntry(result, "partial");
        } else {
            const targetPostId = result && result._id ? result._id : surveyPost._id;
            const ensuredPost = await getOrInitPost(targetPostId);
            submitPartialToServer(result, ensuredPost);
        }
    };

    /**
     * Send a partial page result to the server.
     */
    const submitPartialToServer = async (result, targetPost = null, sync = true) => {
        try {
            const currentPageNo = sync ? result.currentPageNo : result.currentPageNo + 1;
            const postToUse = targetPost || surveyPost;

            await api.saveSurveyPost(postToUse._id, {
                answers: coerceAnswerTypes(result.data),
                currentPage: currentPageNo
            });
            setSurveyPost(postToUse);
        } catch (e) {
            if (e.statusCode && e.statusCode === 403) {
                setRequiresLogin(true);
                setHasLoadedOnce(false);
                setIsAuthenticated(false);
                setSessionErrorMessage(survey && survey.customFields ? survey.customFields.sessionError : null);
            } else {
                const err = new Error(e && e.message ? e.message : "Partial save failed");
                err.context = {
                    ...e,
                    answers: {
                        ...formData,
                        ...result.data
                    },
                    post: surveyPost ? surveyPost : null,
                    completed: false,
                    currentPage: result.currentPageNo + 1
                };
                throw err;
            }
        }
    };

    /**
     * Either fetch an existing post or re-initialize one if it does not exist on the server yet.
     */
    async function getOrInitPost(postId) {
        let existingPost = null;
        await api
            .getPost(postId)
            .then((p) => {
                existingPost = p;
                return true;
            })
            .catch(() => false);

        if (!existingPost) {
            let queryParams = getUrlQueryParameters(null);
            const apiPost = await api.getSurvey(props.match.params.surveyslug, queryParams["prid"]);
            setSurveyPost(apiPost);
            setTemporaryPostId(null);
            return apiPost;
        } else {
            return existingPost;
        }
    }

    /**
     * Attempt to synchronize any locally cached survey entries with the server.
     * Clears the local cache afterward.
     */
    async function syncOfflineSurveys() {
        let stored = await offlineGetAll();
        for (const key of Object.keys(stored)) {
            try {
                const localSurveyData = stored[key];
                await api.refreshSession();

                let ensuredPost = await getOrInitPost(key);

                if (localSurveyData.status === "completed") {
                    await submitSurveyToServer(localSurveyData, ensuredPost, true);
                } else {
                    await submitPartialToServer(localSurveyData.result, ensuredPost);
                }

                // Remove the entry after successful send
                await offlineRemove(key);
                stored = await offlineGetAll();
            } catch (e) {
                // Same strategy: remove the entry even on error to avoid infinite loops
                await offlineRemove(key);
                stored = await offlineGetAll();
            }
        }
        await offlineClear();
    }

    useEffect(() => {
        if (isOnline) {
            syncOfflineSurveys();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOnline]);

    /**
     * Display a loader, optionally with text and background pulled from survey metadata.
     */
    const renderLoading = (text = false) => {
        let customFields = {};
        return (
            <Loader
                text={text}
                backgroundImage={survey ? survey.customFields.backgroundImage : customFields ? customFields.backgroundImage : null}
            />
        );
    };

    /**
     * After login success, reload the survey and mark user/session as connected.
     */
    const handleLoginSuccess = (user) => {
        let authorizedForSurvey = true;
        setIsAuthenticated(true);
        setCurrentUser(user);
        setIsAuthorizedForSurvey(authorizedForSurvey);
        setIsLoading(true);
        fetchSurveyFromApi();
    };

    const renderNotAuthorized = () => {
        return <div>{survey.customFields.notAuthorizedSurvey}</div>;
    };

    /**
     * Render a screen with background image and a centered content block.
     */
    const renderToastedScreen = (content, title) => {
        return (
            <BackgroundedScreen
                backgroundImage={survey.customFields.backgroundImage ? survey.customFields.backgroundImage : null}
                title={title}
            >
                {content}
            </BackgroundedScreen>
        );
    };

    /**
     * Render login flow: loader while checking session, then either the "not authorized" screen or the login form.
     */
    const renderLogin = () => {
        if (isCheckingSession) {
            return <Loader />;
        } else if (isAuthenticated) {
            return renderToastedScreen(
                renderNotAuthorized(),
                <div className={"text-center"}>
                    {survey.customFields.loginLogo ? (
                        <div className={"loginLogo"} style={{ padding: 20 }}>
                            <img alt="Logo" src={survey.customFields.loginLogo} />
                        </div>
                    ) : null}
                    {survey.customFields.loginTitle ? (
                        <div className={"loginTitle"} style={{ padding: 20 }}>
                            {survey.customFields.loginTitle}
                        </div>
                    ) : null}
                    {survey.customFields.loginText ? (
                        <div className={"loginText text-secondary font-weight-light"} style={{ padding: 20 }}>
                            {survey.customFields.loginText.split("\n").map((item, key) => {
                                return <span key={key}>{item}<br/></span>;
                            })}
                        </div>
                    ) : null}
                </div>
            );
        } else {
            return <Login customFields={survey.customFields} onLogin={handleLoginSuccess} connectionError={sessionErrorMessage} />;
        }
    };

    /**
     * Check current session and whether the user is authorized for the survey.
     */
    const checkSessionConnection = async () => {
        setIsCheckingSession(true);
        api
            .getLoggedInUser()
            .then((user) => {
                let authorizedForSurvey = false;
                if (user.authorizedSurveys.indexOf(survey._id) > -1) {
                    authorizedForSurvey = true;
                }
                setIsCheckingSession(false);
                setIsAuthenticated(true);
                setIsAuthorizedForSurvey(authorizedForSurvey);
                setCurrentUser(user);
            })
            .catch(() => {
                setIsCheckingSession(false);
            });
    };

    // Load optional custom CSS declared by the survey
    if (survey && survey.customFields && survey.customFields.customCss) {
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = "/custom-css/" + survey.customFields.customCss;
        const head = document.querySelector("head");
        if (head) head.append(link);
    }

    // Redirects for completion flow
    if (isCompleted) {
        if (survey.customFields.quiz) {
            return <Redirect to={`/survey/result/${surveyPost._id.toString()}`} />;
        } else if (
            typeof survey.customFields.doNotRedirectToCompletePage === "undefined" ||
            !survey.customFields.doNotRedirectToCompletePage
        ) {
            return (
                <Redirect
                    to={`/survey/thankyou/${surveyPost._id.toString()}`}
                    hudReset={showHudReset}
                    hudResetUrl={window.location.href}
                />
            );
        }
    }

    if (errorMessage) {
        return <Error error={errorMessage} title={errorTitle ? errorTitle : null} />;
    }

    if (isLoading) {
        return renderLoading();
    }

    if (surveyModel) {
        if (isCompleted && !surveyModel.isCompleted) {
            surveyModel.doComplete();
        }

        if (surveyModel.onComplete.length === 0) {
            surveyModel.onComplete.add(onComplete);
        }

        if (surveyModel.onPartialSend.length === 0) {
            surveyModel.onPartialSend.add(onPartialSend);
        }

        StylesManager.applyTheme("defaultV2");

        const customCss = {
            rating: {
                root: "custom-rating"
            },
            footer: "custom-footer",
            navigationButton: "custom-nav btn btn-primary"
        };

        const changeLanguage = async (lang) => {
            document.documentElement.lang = lang;
            setActiveLanguage(lang);
            initModel(survey, lang);
        };

        const availableLanguages = surveyModel.getUsedLocales();
        if (availableLanguages.indexOf("fr") === -1) {
            availableLanguages.push("fr");
        }

        return (
            <>
                <style>
                    {`
          body {
            --background: ${survey.style["body-background-color"]};
            --background-dim: ${survey.style["body-container-background-color"]};
            --red-light: ${survey.style["error-background-color"]};
            --red: ${survey.style["error-color"]};
            --background-dim-light: ${survey.style["inputs-background-color"]};
            --primary: ${survey.style["main-color"]};
            --primary-light: ${survey.style["main-hover-color"]};
            --foreground: ${survey.style["text-color"]};
            --foreground-light: ${survey.style["header-color"]};
          }
          .sd-btn--action:not(:disabled):hover, .sd-btn--action:not(:disabled):focus {
            background-color: var(--background-dim);
          }
          .sd-root-modern:not(.svc-tab-designer) .sd-container-modern__title {
            background-color: ${survey.style["header-background-color"]};
          }
          `}
                </style>

                <DocumentTitle title={survey.name}>
                    <BackgroundedScreen
                        large
                        backgroundImage={survey.customFields.backgroundImage ? survey.customFields.backgroundImage : null}
                        customCss={customCss}
                        style={survey.style ? survey.style : null}
                    >
                        {survey.customFields.headerImage ? (
                            <div style={{ marginBottom: 20, textAlign: "center" }}>
                                <img alt="Header" src={survey.customFields.headerImage} style={{ maxWidth: "100%" }} />
                            </div>
                        ) : null}

                        <div className="surveyjs">
                            {availableLanguages && availableLanguages.length > 1 ? (
                                <select
                                    style={{
                                        position: "absolute",
                                        right: 10,
                                        top: 10,
                                        padding: "8px 10px",
                                        borderRadius: 10,
                                        background: "white",
                                        border: "0",
                                        textTransform: "uppercase"
                                    }}
                                    onChange={(e) => changeLanguage(e.target.value)}
                                    value={surveyModel.getLocale()}
                                >
                                    {availableLanguages.map((language, index) => (
                                        <option key={index} value={language}>
                                            {language}
                                        </option>
                                    ))}
                                </select>
                            ) : null}

                            {showHudStatus ? <ConnectionStatus /> : ""}

                            {showHudReset && showRelaunchButton ? (
                                <ResetSurveyButton loadStaticSurvey={loadSurveyFromLocalCache} hudResetUrl={window.location.href} />
                            ) : (
                                ""
                            )}

                            <Survey model={surveyModel} data={formData} />
                        </div>
                    </BackgroundedScreen>
                </DocumentTitle>
            </>
        );
    }

    if (requiresLogin && (!isAuthenticated || !isAuthorizedForSurvey)) {
        return renderLogin();
    }

    return null;
}
